import React, { PureComponent } from 'react'
import autobind from 'autobind-decorator'
import { browserHistory } from 'react-router'
import styles from './styles'

import Controller from 'app/Components/FormsController'

import Alert from 'app/Components/Alert'
import BottomBar from '../../BottomBar'

import NameInput from 'app/Components/FormInput/NameInput'
import EmailInput from 'app/Components/FormInput/EmailInput'
import CompanyInput from 'app/Components/FormInput/CompanyInput'

export default class Form extends PureComponent {
  state = { valid: false, emailVaild: false, intial: true }

  get valid() {
    if (!this.state.valid && !this.state.intial) {
      return (<Alert message='Please fill in all fields' />)
    }
  }

  get validEmail() {
    if (!this.state.emailVaild && !this.state.intial) {
      return (<Alert message='Please enter a valid email' />)
    }
  }

  isEmailValid(email) {
    let value = Controller.email
    let isValid = value.match(/.+@.+\..+/)
    return isValid
  }

  @autobind next() {
    const fullname = Controller.fullname
    const email = Controller.email
    const company = Controller.company
    if (!(fullname && email && company)) {
      this.setState({ valid: false, intial: false, emailVaild: true })
    } else if (!this.isEmailValid(email)) {
      this.setState({ valid: true, intial: false, emailVaild: false })
    } else {
      browserHistory.push('/survey/')
    }
  }

  @autobind goBack() {
    browserHistory.push('/')
  }

  @autobind goToNext(event) {
    if (event.key === 'Enter') {
      if (event.target.name === 'Fullname') this.refs.email.focus()
      else if (event.target.name === 'Email') this.refs.company.focus()
      else if (event.target.name === 'Company') this.next()
    }
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <form method='post' action='#' ref='form' >
          <NameInput />
          <EmailInput />
          <CompanyInput />
        </form>
        { this.valid }
        { this.validEmail }
        <BottomBar
          goBack={this.goBack}
          next={this.next}
          text='Next'
          disabled={false/* TODO */}
        />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Survey/Panel/Form/Form.js
 **/